import './LoaderOverlay.css';
export var loaderOverlay = '_bs5vaz0-3-12-1';
export var progressCircle = '_bs5vaz1-3-12-1';